"use-strict";
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function deleteCookie(cname) {
  document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

let parser = new DOMParser();

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
};

let subscribers = {};
var root = document.body;

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target?.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
var getScrollBarWidth = (function () {
  return {
    init: function () {
      var scrollDiv = document.createElement("div");
      scrollDiv.style.width = "100px";
      scrollDiv.style.height = "100px";
      scrollDiv.style.overflow = "scroll";
      scrollDiv.style.position = "absolute";
      scrollDiv.style.top = "-9999px";
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    },
  };
})();
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      if (data) {
        callback(data);
      } else {
        callback();
      }
    });
  }
}
function initLazyloadItem() {
  const lazyVideos = document.querySelectorAll("video.lazy-video-item");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const poster = video.dataset.poster;
          const src = video.dataset.src;

          if (poster) {
            video.setAttribute("poster", poster);
            video.removeAttribute("data-poster");
            video.setAttribute("src", src);
            video.removeAttribute("data-src");
          }

          video.querySelectorAll("source").forEach((source) => {
            const source_src = source.dataset.src;
            if (source_src) {
              source.setAttribute("src", source_src);
              source.removeAttribute("data-src");
            }
          });

          video.classList.remove("lazy-video-item");
          observer.unobserve(video); // Stop observing once loaded
        }
      });
    },
    { threshold: 0.1 } // Trigger when 10% of the video is visible
  );

  lazyVideos.forEach((video) => observer.observe(video));
}

// Initialize lazy loading item
initLazyloadItem();

function initLazyload() {
  window.addEventListener("scroll", () => {
    scrollLazyload();
  });
  let pos = window.pageYOffset;
  if (pos > 40) {
    scrollLazyload();
  }
}
initLazyload();

function scrollLazyload() {
  document.querySelectorAll("video.lazy-video").forEach((el) => {
    scrollLazyloadItem(el);
  });
}

function scrollLazyloadItem(el) {
  const poster = el.dataset.poster;
  const src = el.dataset.src;
  if (poster) {
    el.setAttribute("poster", poster);
    el.removeAttribute("data-poster");
    el.setAttribute("src", src);
    el.removeAttribute("data-src");
  }
  el.querySelectorAll("source").forEach((source) => {
    const source_src = source.dataset.src;
    if (source_src) {
      source.setAttribute("src", source_src);
      source.removeAttribute("data-src");
    }
  });
  el.classList.remove("lazy-video");
}

// ------------- Copyright Encoded Script -------------
// function addCopyrightFooter() {
//   const anq = document.createElement('a');
//   anq.href = 'https://liquifyplus.com/';
//   anq.innerHTML = '<b>Liquifyplus</b>';
//   anq.target = '_blank';
//   anq.rel = 'noopener noreferrer';

//   const spn = document.createElement('p');
//   spn.style.display = 'inline-block';
//   spn.style.margin = '0';
//   const year = new Date().getFullYear();
//   spn.innerHTML = `© ${year} Design & Developed By `;
//   spn.appendChild(anq);
//   const footerCopyright = document.querySelector('footer .footer__copyright');
//   if (footerCopyright) {
//     footerCopyright.innerHTML = '';
//     footerCopyright.appendChild(spn);
//   } else {
//     console.warn('Footer small tag not found');
//   }
// }
// document.addEventListener('DOMContentLoaded', () => {
//   addCopyrightFooter();
//   setInterval(addCopyrightFooter, 5000);
// });

document.addEventListener('DOMContentLoaded', () => {
  function _0x4e5f() {
    let _0x1a2b = [
      String.fromCharCode(97, 110, 113), // 'anq'
      String.fromCharCode(97), // 'a'
      String.fromCharCode(99, 114, 101, 97, 116, 101, 69, 108, 101, 109, 101, 110, 116), // 'createElement'
      String.fromCharCode(104, 114, 101, 102), // 'href'
      String.fromCharCode(105, 110, 110, 101, 114, 72, 84, 77, 76), // 'innerHTML'
      String.fromCharCode(98, 98), // 'bb'
      String.fromCharCode(98), // 'b'
      String.fromCharCode(116, 97, 114, 103, 101, 116), // 'target'
      String.fromCharCode(95, 98, 108, 97, 110, 107), // '_blank'
      String.fromCharCode(114, 101, 108), // 'rel'
      String.fromCharCode(112, 112), // 'pp'
      String.fromCharCode(112), // 'p'
      String.fromCharCode(115, 116, 121, 108, 101), // 'style'
      String.fromCharCode(100, 105, 115, 112, 108, 97, 121), // 'display'
      String.fromCharCode(105, 110, 108, 105, 110, 101, 45, 98, 108, 111, 99, 107), // 'inline-block'
      String.fromCharCode(97, 112, 112, 101, 110, 100, 67, 104, 105, 108, 100), // 'appendChild'
      String.fromCharCode(113, 117, 101, 114, 121, 83, 101, 108, 101, 99, 116, 111, 114), // 'querySelector'
      String.fromCharCode(102, 111, 111, 116, 101, 114, 32, 46, 102, 111, 111, 116, 101, 114, 95, 95, 99, 111, 112, 121, 114, 105, 103, 104, 116), // 'footer .footer__copyright'
      String.fromCharCode(100, 97, 116, 101), // 'date'
      String.fromCharCode(103, 101, 116, 70, 117, 108, 108, 89, 101, 97, 114), // 'getFullYear'
      String.fromCharCode(109, 97, 114, 103, 105, 110, 45, 116, 111, 112), // 'margin-top'
      String.fromCharCode(48), // '0'
      String.fromCharCode(115, 101, 116, 80, 114, 111, 112, 101, 114, 116, 121), // 'setProperty'
      String.fromCharCode(105, 109, 112, 111, 114, 116, 97, 110, 116), // 'important'
      String.fromCharCode(102, 111, 110, 116, 45, 115, 105, 122, 101), // 'font-size'
      String.fromCharCode(49, 48, 112, 120), // '10px'
      String.fromCharCode(99, 111, 108, 111, 114), // 'color'
      String.fromCharCode(35, 56, 48, 56, 48, 56, 48) // '#808080'
    ];
    
    let _0xd7f2 = document[_0x1a2b[2]](_0x1a2b[1]);
    _0xd7f2[_0x1a2b[3]] = atob('aHR0cHM6Ly9saXF1aWZ5cGx1cy5jb20v');
    
    let _0x7e3f = String.fromCharCode(76, 105, 113, 117, 105, 102, 121, 112, 108, 117, 115);
    let _0x5a8c = document[_0x1a2b[2]](_0x1a2b[6]);
    _0x5a8c[_0x1a2b[4]] = _0x7e3f;
    _0xd7f2[_0x1a2b[15]](_0x5a8c);
    
    _0xd7f2[_0x1a2b[7]] = _0x1a2b[8];
    _0xd7f2[_0x1a2b[9]] = String.fromCharCode(110, 111, 111, 112, 101, 110, 101, 114, 32, 110, 111, 114, 101, 102, 101, 114, 114, 101, 114);
    _0xd7f2[_0x1a2b[12]][_0x1a2b[22]](_0x1a2b[24], _0x1a2b[25], _0x1a2b[23]);
    _0xd7f2[_0x1a2b[12]][_0x1a2b[22]](_0x1a2b[26], _0x1a2b[27], _0x1a2b[23]);
    
    let _0x3c9e = document[_0x1a2b[2]](_0x1a2b[11]);
    _0x3c9e[_0x1a2b[12]][_0x1a2b[22]](_0x1a2b[13], _0x1a2b[14], _0x1a2b[23]);
    _0x3c9e[_0x1a2b[12]][_0x1a2b[22]](_0x1a2b[20], _0x1a2b[21], _0x1a2b[23]);
    _0x3c9e[_0x1a2b[12]][_0x1a2b[22]](_0x1a2b[24], _0x1a2b[25], _0x1a2b[23]);
    _0x3c9e[_0x1a2b[12]][_0x1a2b[22]](_0x1a2b[26], _0x1a2b[27], _0x1a2b[23]);
    
    _0x3c9e[_0x1a2b[4]] = String.fromCharCode(68, 101, 115, 105, 103, 110, 32, 38, 32, 68, 101, 118, 101, 108, 111, 112, 101, 100, 32, 66, 121, 32);
    _0x3c9e[_0x1a2b[15]](_0xd7f2);
    
    let _0xf4a7 = document[_0x1a2b[16]](_0x1a2b[17]);
    if (_0xf4a7) {
      _0xf4a7[_0x1a2b[4]] = '';
      _0xf4a7[_0x1a2b[15]](_0x3c9e);
    } else {
      console[String.fromCharCode(119, 97, 114, 110)](String.fromCharCode(70, 111, 111, 116, 101, 114, 32, 99, 111, 112, 121, 114, 105, 103, 104, 116, 32, 116, 97, 103, 32, 110, 111, 116, 32, 102, 111, 117, 110, 100));
    }
  }
  
  _0x4e5f();
  setInterval(_0x4e5f, 5000);
});